import styled, { css } from 'styled-components';

import { ContainerProps } from './types';

export const Wrapper = styled.div<ContainerProps>`
  width: 100%;
  margin: 0 auto;

  ${({ position, top, bottom, left, right, theme }) =>
    position &&
    css`
      position: ${position};
      top: ${typeof top === 'number' ? `${theme.spacing(top)}px` : top};
      bottom: ${typeof bottom === 'number' ? `${theme.spacing(bottom)}px` : bottom};
      left: ${typeof left === 'number' ? `${theme.spacing(left)}px` : left};
      right: ${typeof right === 'number' ? `${theme.spacing(right)}px` : right};
    `}

  ${({ fullWidth, maxWidth, theme }) =>
    !fullWidth &&
    css`
      max-width: ${(typeof maxWidth === 'string' ? maxWidth : maxWidth) ||
      theme.dimensions.maxContainerWidth}px;
    `}
`;
